module.exports = __webpack_public_path__ + "static/img/4.USB-Terminal-1.9d04df1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/4.USB-Terminal-1.jpg
// module id = rbdg
// module chunks = 1